import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { calcRemaining, isEndBeforeStart } from './Utils/DateUtil';
import { Slot } from '../../Model/Slot';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';
import { canEditSlotDates } from '../../../../Utils/limitedPartnerAdmin';

export class UpdateSlotUseCase {
  constructor(private repo: SlotRepository) {}

  execute(id: number, dto: Partial<Slot>, current: User) {
    if (isSlotOperationRestricted(current)) {
      throw new Error(getRestrictionMessage('수정', current));
    }

    if (!canEditSlotDates(current)) {
      delete dto.start_date;
      delete dto.end_date;
    }

    // 순위 조회 상태는 테이블 표시용 응답 필드. 수정 요청에 포함하지 않음.
    delete dto.rank_check_status;
    delete dto.today_rank;
    delete dto.yesterday_rank;
    delete dto.rank_history;
    delete dto._rankPending;
    delete dto._optimistic;

    // 종료일이 시작일보다 앞설 수 없음 (둘 다 제공된 경우)
    if (dto.start_date && dto.end_date && isEndBeforeStart(dto.start_date, dto.end_date)) {
      throw new Error('종료일은 시작일보다 이전일 수 없습니다.');
    }

    return this.repo
      .updateSlot(id, dto)
      .then(s => ({ ...s, remaining_days: calcRemaining(s.end_date) }));
  }
}
